import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaBox } from "react-icons/fa";
import "../style/GoodsDetails.css";
import { toast } from "react-toastify";

function GoodsDetails() {

  const { id } = useParams();
  const navigate = useNavigate();

  console.log("GoodsDetails component loaded with customer ID:", id);

  const [goodsItems, setGoodsItems] = useState([]);
  const [customerName, setCustomerName] = useState("");
  const [totalDeposit, setTotalDeposit] = useState(0);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");

  /* ================= FETCH GOODS ================= */

  useEffect(() => {

    const fetchGoods = async () => {

      try {
        const res = await fetch(
          `https://ctmapi.zerlak.com/api/v1/challans/getCustomersInventoryItems/${id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          }
        );

        if (!res.ok) throw new Error("Failed to fetch goods");

        const data = await res.json();
        console.log("API Response:", data);

        // The API returns an array directly, not wrapped in goodsItems
        const items = Array.isArray(data) ? data : (data.goodsItems || []);
        console.log("Processed items:", items);

        setGoodsItems(items);

        // Customer name is not in the API response, so we'll use a default
        setCustomerName(`Customer ${id}`);

        // Calculate total from delivered/received quantities or any available numeric field
        const total = items.reduce(
          (sum, item) => sum + (item.deliveredQty || 0) + (item.receivedQty || 0),
          0
        );

        setTotalDeposit(total);

      } catch (err) {
        console.error(err);
        toast.error("Failed to load goods");
      } finally {
        setLoading(false);
      }
    };

    fetchGoods();

  }, [id, token]);

  /* ================= FORMAT MONEY ================= */

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR"
    }).format(amount || 0);
  };

  /* ================= LOADING ================= */

  if (loading) {
    return (
      <div className="goods-overlay">
        <div className="goods-modal">
          <div className="loading-state">
            <FaBox />
            <p>Loading goods...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="goods-overlay">

      <div className="goods-modal">

        {/* HEADER */}
        <h2 className="title"> Goods Details</h2>

        {/* COLUMN HEADERS */}
        <div className="table-header">
          <span>Item Name</span>
          <span>Received Qty</span>
          <span>Delivered Qty</span>
        </div>

        {/* ITEMS */}
        <div className="goods-list">

          {goodsItems.length === 0 ? (
            <p className="no-data">No goods found</p>
          ) : (
            goodsItems.map((item, index) => (
              <div className="goods-row" key={index}>

                <span className="item-name">
                  {item.name || item.itemName || 'Unknown Item'}
                </span>

                <span className="received">
                  {item.receivedQty || 0}
                </span>

                <span className="delivered">
                  {item.deliveredQty || 0}
                </span>

              </div>
            ))
          )}

        </div>

        {/* TOTAL DEPOSIT */}
        <div className="deposit">
          Deposit: {formatCurrency(totalDeposit)}
        </div>

        {/* CLOSE BUTTON */}
        <button
          className="close-btn"
          onClick={() => navigate(-1)}
        >
          Close
        </button>

      </div>

    </div>
  );
}

export default GoodsDetails;